import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
    
    return !localStorage.getItem("userData") ? <Outlet /> : <Navigate to="/home" />;
}
export default PrivateRoute